class Columns extends Immutable.Record({
    cols: Immutable.OrderedMap()
}) {
    setColumnVisibility(id, hidden) {
        return this.set('cols', this.get('cols').update(id, c =>
            c.set('ModuleConfigGridColumn', c.get('ModuleConfigGridColumn').set('is_hidden', hidden ? '1' : '0'))));
    }
    getDefaultSort() {
        var col;
        this.get('cols').forEach(c => {
            if (c.isDefaultSort()) {
                col = c;
                return false;
            }
        });
        return col;
    }
}

class Column extends Immutable.Record({
    alias: '',
    formatted: {
        component: '',
        props: {}
    },
    ModuleConfigGridColumn: {
        // the commented fields are not used, thus not required
        //id: 0,
        //module_item_id: 0,
        field: '',
        label: '',
        sort_direction: 'ASC',
        is_default_sort: false,
        is_hidden: false
        //order: 0
    }
}) {
    isHidden() {
        var v = this.get('ModuleConfigGridColumn').get('is_hidden');
        if (typeof(v) == 'boolean') {
            return v;
        }
        return !!parseInt(v)
    }
    isDefaultSort() {
        var v = this.get('ModuleConfigGridColumn').get('is_default_sort');
        if (typeof(v) == 'boolean') {
            return v;
        }
        return !!parseInt(v)
    }
}

// Reviver, used with Immutable.fromJS().
// https://facebook.github.io/immutable-js/docs/#/fromJS
function ColumnsFromJS(key, value) {
    var isIndexed = Immutable.Iterable.isIndexed(value);
    if (isIndexed) {
        if (value.getIn([0, 'ModuleConfigGridColumn', 'id'], null) !== null) {
            return value.toKeyedSeq().mapKeys((_, v) => v.getIn(['ModuleConfigGridColumn', 'id'])).toOrderedMap()
        }
        return value.toList();
    }

    // associative
    if (value.get('ModuleConfigGridColumn', null) !== null) {
        return new Column({
            alias: value.get('alias'),
            formatted: value.get('formatted'),
            ModuleConfigGridColumn: value.get('ModuleConfigGridColumn')
        });
    }
    return value.toMap();
}